import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoginService} from '../shared/services/login.service';
import { GlobalService } from '../shared/services/global.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

  goToLogin(){
    window.location.href = this._gS.service_url + 'saml_okta/init'
    // window.location.href = "https://login.spe.sony.com/app/spe_productionlogikstage_1/exkxftw6h4Mhsdnvw357/sso/saml"
    // window.location.href = "https://login.spe.sony.com/app/spe_productionlogikqa_1/exkwsacy1zHvmdkSL357/sso/saml"
  	// window.location.href = "https://adfs.sony.com/adfs/ls/idpinitiatedsignon.aspx";
    // window.location.href = "http://localhost:3000/saml/skipAuth";
  }

  goToLoginWithToken() {

  }
  constructor(private _lS:LoginService, public _gS: GlobalService) { }

  ngOnInit() {
  }

}
